export default "__VITE_ASSET__86a5cc3d__"